import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { MobileWeb } from "../components/mobile/BreakPoint";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    width: 1440,
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 20,
    // borderTop: "1px solid #EB4FE5",
    // backgroundColor: "#c8c8c8",
    "&:second-child": {
      pading: "0px 10px",
      borderRight: "1px solid #c4c4c4",
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      display: "none",
    },
  },
  items: {
    display: "flex",
    fontSize: 15,
    marginRight: 20,
    paddingRight: 20,
    borderRight: "1px solid #c4c4c4",
  },
  lastitems: {
    display: "flex",
    fontSize: 15,
    marginRight: 20,
    paddingRight: 20,
  },
}));

export const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <div className={classes.items}>(주)휴먼브릿지</div>
      <div className={classes.items}>대표자: 임지영</div>
      <div className={classes.items}>
        인천광역시 미추홀구 인하로 100, 5남 369호
      </div>
      {/* <div className={classes.items}>고객센터: 032-000-0000</div> */}
      <div className={classes.items}>개인정보처리방침</div>
      <div className={classes.lastitems}>
        Copyright &copy; 2021 (주)휴먼브릿지. All rights reserved
      </div>
    </div>
  );
};
